module.exports = __webpack_public_path__ + "static/media/leafs_yc.3ce2030c.svg";